"use strict";var $export=require("./_export"),cof=require("./_cof");$export($export.S,"Error",{isError:function(r){return"Error"===cof(r)}});